var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 2C6.45021 2 1.97021 6.48 1.97021 12C1.97021 17.52 6.45021 22 11.9702 22C17.4902 22 21.9702 17.52 21.9702 12C21.9702 6.48 17.5002 2 11.9702 2ZM14.9702 14.23L12.0702 15.9C11.7102 16.11 11.3102 16.21 10.9202 16.21C10.5202 16.21 10.1302 16.11 9.77022 15.9C9.05021 15.48 8.62021 14.74 8.62021 13.9V10.55C8.62021 9.72 9.05021 8.97 9.77022 8.55C10.4902 8.13 11.3502 8.13 12.0802 8.55L14.9802 10.22C15.7002 10.64 16.1302 11.38 16.1302 12.22C16.1302 13.06 15.7002 13.81 14.9702 14.23Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnVideoIcon);
export default __webpack_public_path__ + "static/media/LearnVideoIcon.857e67fa1600a578e85408e4725e516f.svg";
export { ForwardRef as ReactComponent };